import React from 'react';
import Ticket from '../../../interfaces/ticket/Ticket';
import Sprint from '../../../interfaces/sprint/Sprint';
import IssuesBoard from '../IssuesPage/IssuesBoard';
import { ReorderRequest } from '../../../interfaces/ticket/ReorderRequest';

interface BacklogViewProps {
    tickets: Ticket[];
    sprints: Sprint[];
    onTicketSprintChange: (payload: ReorderRequest) => void;
    onTicketClick: (ticketId: string) => void;
}

const BacklogView: React.FC<BacklogViewProps> = ({ tickets, sprints, onTicketSprintChange, onTicketClick }) => {
    // The IssuesBoard component can be repurposed to show the backlog and other sprints.
    // We can filter the sprints to exclude the active one if needed, but for a backlog view,
    // showing all non-completed sprints might be desirable.

    return (
        <div className="backlog-view">
            <IssuesBoard 
                tickets={tickets} 
                sprints={sprints.filter(s => !s.completed)} 
                onTicketReorder={onTicketSprintChange} 
                onTicketClick={onTicketClick}
            />
        </div>
    );
};

export default BacklogView;
